import { Mountain, Flame, TreePine, Trophy, Users, Church } from "lucide-react";
import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

const ICONS = [Mountain, Flame, TreePine, Trophy, Users, Church];
const IMAGES = [
  "https://images.unsplash.com/photo-1551632811-561732d1e306?w=900&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=900&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1486915309851-b0cc1f8a0084?w=900&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1697926156905-c4fcd0504936?w=900&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=900&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=900&q=80&auto=format&fit=crop",
];

const Activities = () => {
  const { t } = useLanguage();
  const items = t.activities.items;

  return (
    <section id="activities" className="relative py-24 lg:py-36 bg-anthracite text-cream overflow-hidden">
      {/* Decorative gold corner */}
      <div className="pointer-events-none absolute -top-32 -right-32 w-96 h-96 rounded-full" style={{ background: "radial-gradient(circle, rgba(198,156,34,0.18) 0%, transparent 70%)" }} />

      <div className="container-boe relative">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#E5C76B" }}>
            <span className="w-7 h-px bg-gold" /> {t.activities.eyebrow}
          </span>
          <h2 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
            {t.activities.title}
          </h2>
          <p className="mt-6 text-lg text-cream/75 max-w-xl">{t.activities.subtitle}</p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={item.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
                className="group relative overflow-hidden rounded-3xl aspect-[4/5] border border-cream/10"
              >
                <img src={IMAGES[i]} alt={item.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

                <div className="relative h-full flex flex-col justify-end p-7">
                  <div className="w-11 h-11 rounded-full bg-gold/20 backdrop-blur-md flex items-center justify-center mb-4 border border-gold/40">
                    <Icon size={18} className="text-gold-soft" style={{ color: "#E5C76B" }} strokeWidth={1.7} />
                  </div>
                  <h3 className="font-accent italic text-3xl font-medium leading-none mb-2">{item.name}</h3>
                  <p className="text-sm text-cream/80 leading-relaxed max-w-xs">{item.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Activities;
